(() => {
  const qty = document.querySelector('[data-pitb-qty]');
  if (qty) {
    const input = qty.querySelector('.pitb-pdp__qty-input');
    const syncQuantity = () => {
      if (!input) return;
      const max = input.max ? Number(input.max) || 1 : Infinity;
      input.value = String(Math.min(max, Math.max(1, parseInt(input.value, 10) || 1)));
      const plus = qty.querySelector('[data-pitb-qty-plus]');
      if (plus) plus.disabled = Number(input.value) >= max;
    };
    syncQuantity();
    input?.addEventListener('change', syncQuantity);
    qty.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-pitb-qty-minus]');
      const plus = event.target.closest('[data-pitb-qty-plus]');
      if (!input || (!minus && !plus) || (plus && plus.disabled)) return;
      const current = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = String(minus ? Math.max(1, current - 1) : current + 1);
      syncQuantity();
    });
  }

  const media = document.querySelector('.pitb-pdp__media');
  const main = media && media.querySelector('img.pitb-pdp__img, img');
  const loader = media && media.querySelector('.pitb-pdp__media-loading');
  const thumbs = document.querySelectorAll('[data-pitb-thumb]');
  let loadToken = 0;

  const setLoading = (on) => {
    if (!media) return;
    media.classList.toggle('is-loading', on);
    media.setAttribute('aria-busy', on ? 'true' : 'false');
    if (loader) {
      loader.hidden = !on;
      loader.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
  };

  const showThumb = (thumb) => {
    if (!main || !thumb) return;
    const href = thumb.getAttribute('data-full') || thumb.getAttribute('href');
    const srcset = thumb.getAttribute('data-srcset');
    if (!href) return;

    const sameSrc = main.getAttribute('src') === href;
    thumbs.forEach((el) => el.classList.toggle('is-active', el === thumb));
    if (sameSrc && main.complete) return;

    const token = ++loadToken;
    setLoading(true);

    const finish = () => {
      if (token !== loadToken) return;
      setLoading(false);
    };

    main.addEventListener('load', finish, { once: true });
    main.addEventListener('error', finish, { once: true });

    main.removeAttribute('srcset');
    main.src = href;
    if (srcset) main.setAttribute('srcset', srcset);
    else main.setAttribute('srcset', href);

    // Cached images may already be complete after src assignment.
    if (main.complete && main.naturalWidth > 0) {
      finish();
    }
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      showThumb(thumb);
    });
  });
})();
